export const REFRESH_CHANNEL_LIST_EVENT = "RefreshChannelList"

/** /api/chats/list/by_type 列表类型：2=已订阅频道，3=推荐频道 */
export const CHANNEL_LIST_API_TYPE = {
  SUBSCRIBED: 2,
  RECOMMENDED: 3,
} as const

export type ChannelListSectionKey = "subscribed"

/** 统一解析 /api/chats/list/by_type 列表字段 */
export function extractChannelListItems(result: unknown): any[] {
  if (Array.isArray(result)) return result
  if (result == null || typeof result !== "object") return []

  const payload = result as { code?: number | string; data?: unknown; message?: string }
  const codeNum =
    payload.code == null || payload.code === ""
      ? null
      : Number(payload.code)

  if (codeNum != null && Number.isFinite(codeNum) && codeNum !== 200 && codeNum !== 0) {
    throw new Error(String(payload.message || "请求失败"))
  }

  const data = payload.data
  if (Array.isArray(data)) return data
  if (data != null && typeof data === "object") {
    const nested = data as { items?: unknown; list?: unknown; data?: unknown; records?: unknown }
    if (Array.isArray(nested.items)) return nested.items
    if (Array.isArray(nested.list)) return nested.list
    if (Array.isArray(nested.data)) return nested.data
    if (Array.isArray(nested.records)) return nested.records
  }
  return []
}
